(function () {
    'use strict';

    angular
        .module('app.audit')
        .run(appRun);

    appRun.$inject = ['routerHelper'];
    /* @ngInject */
    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'audit',
                config: {
                    url: '/audit',
                    abstract: true,
                    template: '<ui-view/>',
                    ncyBreadcrumb: {
                        label: 'Audit'
                    },
                    data: {
                        permissions: {
                            only: ['SSO:SysAdmin', 'SSO:AppAdmin'],
                            redirectTo: function () {
                                return {
                                    state: 'error.403',
                                    options: {
                                        reload: true
                                    }
                                };
                            }
                        }
                    }
                }
            },
            {
                state: 'audit.dashboard',
                config: {
                    url: '/dashboard',
                    templateUrl: 'app/audit/dashboard/audit.dashboard.html',
                    controller: 'AuditLoggingController',
                    controllerAs: 'vm',
                    title: 'Audit Logging',
                    //ncyBreadcrumb: {
                    //    label: 'Dashboard'
                    //},
                    settings: {
                        isVisible: true,
                        nav: 5,
                        content: '<i class="fa fa-file-text"></i> Audit Logging'
                    }
                }
            }
        ];
    }
})();
